export default "__VITE_ASSET__XJOEPS4A__"